/*----------------------------------
- DEPENDANCES
----------------------------------*/

// Npm
import React from 'react';

// Core
import useContext from '@/client/context';
import { Button } from '@client/components';

// app
import type { Announcement } from '@models/types';

/*----------------------------------
- TYPES
----------------------------------*/

/*----------------------------------
- COMPONENT
----------------------------------*/
export default ({ close, announcements }: {
    close: (res: boolean) => void,
    announcements: Announcement[]
}) => {

    const { api } = useContext();

    const [current, setCurrent] = React.useState(0);

    const announcement = announcements[ current ];

    const closeCurrent = () => {

        // Don't show next time
        api.post('/feedbacks/announcements/read', {
            id: announcement.airtableId
        }).run()

        // Close modal
        if (current === announcements.length - 1)
            close(true);
        // Show next announcement
        else
            setCurrent( index => index + 1 );

    }

    return (
        <div class="card col w-5">

            <Button icon="times" shape="icon" size="s" class="close" 
                onClick={closeCurrent} />
            
            <h2 class="mgt-1">{announcement.title}</h2>

            <p dangerouslySetInnerHTML={{ __html: announcement.text }} />

            {(announcement.ctaText && announcement.ctaUrl) && (
                <Button type="primary" link={announcement.ctaUrl}>
                    {announcement.ctaText}
                </Button>
            )}

        </div>
    )
}